module.exports = __webpack_public_path__ + "media/v2/components/PrizesPage/shared/img/1-2487d40689371d32061e18c4bae5922c.png";